import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
export interface Tile {
  id: number;
  image_src: string;
}
@Component({
  selector: "app-guardian-list",
  templateUrl: "./guardian-list.component.html",
  styleUrls: ["./guardian-list.component.css"],
})
export class GuardianListComponent implements OnInit {
  constructor(private router: Router) { }

  tiles: Tile[] = [
    {
      id: 1,
      image_src: "assets/images/test/guardian/guardian_list/guardians/001.jpg",
    },
    {
      id: 2,
      image_src: "assets/images/test/guardian/guardian_list/guardians/002.jpg",
    },
    {
      id: 3,
      image_src: "assets/images/test/guardian/guardian_list/guardians/003.jpg",
    },
    {
      id: 4,
      image_src: "assets/images/test/guardian/guardian_list/guardians/004.jpg",
    },
    {
      id: 5,
      image_src: "assets/images/test/guardian/guardian_list/guardians/005.jpg",
    },
    {
      id: 6,
      image_src: "assets/images/test/guardian/guardian_list/guardians/006.jpg",
    },
    {
      id: 7,
      image_src: "assets/images/test/guardian/guardian_list/guardians/007.jpg",
    },
    {
      id: 8,
      image_src: "assets/images/test/guardian/guardian_list/guardians/008.jpg",
    },
  ];
  ngOnInit(): void { }

  fnItem(id: string) {
    // this.router.navigate(["/guardianes-item", id]);

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(["/guardianes-item", id]).then(() => {
      })
    })

  }
}
